import { useContext } from 'react';
import ToastContext from 'src/contexts/toast-context';
import SelectAttachment from 'src/components/post/SelectAttachment';
import Attachment from 'src/components/post/Attachment';
import '../../styles/CustomStyle.css';

const Attachments = ({
  attachments,
  link,
  onLinkDelete,
  onLinkSave,
  setAttachments,
  captions,
  setCaptions,
}) => {
  const { error } = useContext(ToastContext);
  const disableDocumentUpload = attachments?.length >= 5;
  const disableLinkUpload = link?.length > 0;
  const fileSizeLimit = 40 * 1024 * 1024;
  const MAX_FILENAME_LENGTH = 50;

  const handleFileInput = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) {
      return;
    }
    if (!isValidFile(selectedFile)) {
      error('Please select a valid file.');
      return;
    }
    if (!isUnderSizeLimit(selectedFile)) {
      error('Please select a file under 40MB.');
      return;
    }
    if (selectedFile.name.length > MAX_FILENAME_LENGTH) {
      error('Filename is too long. Please select a file with a shorter name.');
      return;
    }
    setAttachments((currentAttachments) => [...currentAttachments, selectedFile]);
    setCaptions((currentCaptions) => [...currentCaptions, '']); // add a new caption
  };

  const handleAttachmentDelete = (attachmentToDelete) => {
    const index = attachments.indexOf(attachmentToDelete);
    setAttachments((currentAttachments) =>
      currentAttachments.filter((attachment) => attachment !== attachmentToDelete)
    );
    setCaptions((currentCaptions) => {
      const newCaptions = [...currentCaptions];
      newCaptions.splice(index, 1);
      return newCaptions;
    });
  };

  const handleCaptionChange = (index, newCaption) => {
    setCaptions((currentCaptions) => {
      const newCaptions = [...currentCaptions];
      newCaptions[index] = newCaption;
      return newCaptions;
    });
  };

  const isValidFile = (file) => {
    const allowedMimeTypes = [
      'application/pdf',
      'image/png',
      'image/jpeg',
      'image/jpg',
      'video/mp4',
      'video/avi',
    ];
    return allowedMimeTypes.includes(file.type);
  };

  const isUnderSizeLimit = (file) => {
    return file.size <= fileSizeLimit;
  };

  return (
    <div className="attachments">
      {attachments?.map((attachment, index) => (
        <div className="attachment no-border-radius" key={index}>
          <Attachment
            item={attachment}
            key={index}
            title={attachment.originalFileName || attachment.name}
            onDelete={() => handleAttachmentDelete(attachment)}
          />
          <div className="mb-3 flex items-center m-2 gap-3">
            <label htmlFor="attachmentCaption">Caption</label>
            <input
              type="text"
              id="attachmentCaption"
              placeholder="Enter caption"
              value={captions?.[index] || ''}
              onChange={(e) => handleCaptionChange(index, e.target.value)}
              maxLength={500}
              className="block rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
      ))}
      {link && <Attachment item={link} onDelete={onLinkDelete} title={'Youtube Video'} />}
      <SelectAttachment
        handleFileInput={handleFileInput}
        onLinkSave={onLinkSave}
        disableDocumentUpload={disableDocumentUpload}
        disableLinkUpload={disableLinkUpload}
      />
    </div>
  );
};

export default Attachments;
